import React, {Component, Fragment} from 'react'
import PropTypes from "prop-types"
import {connect} from 'react-redux'
import {reduxForm, Field, getFormValues, isValid} from 'redux-form'
import Dropzone from 'react-dropzone'
import {importSubmit, reuploadQuestions, importQuestionsSuccess} from '../../../modules/questions'
import {parentCategoriesSelector, subcategoriesSelector} from '../../../modules/categories'
import {
    successImportMsg,
    okImportText,
    cancelImportText,
    getImportAcceptedFormats,
    importFormName,
    stringifyAcceptedFormats,
    checkImportExportMenuDataItem,
    checkImportFileType,
    importId,
    importQtizipId,
    importMsexcelId
} from '../../../helpers/importExport'
import {required} from '../../common/Form/rules'
import Select from 'react-select'
import {sortCB} from "../../../helpers/common"
import {showLoading, hideLoading} from 'react-redux-loading-bar'
import {qLoaderShowModal, qLoaderHideModal} from '../../../modules/modals'
import {LOADER_BAR_MODAL_SCOPE, LOADER_BAR_Q_LOADER_MODAL_SCOPE} from '../../../settings/constants'


class ImportForm extends Component {
    state = {
        fileErrors : {
            format : "",
        },
    }
    render() {
        const {handleSubmit, submitSucceeded, error, submitting, onCancelClick, isFormValid, what} = this.props
        const {formatMessage} = this.context
        const {fileErrors} = this.state

        const categories = this._getCategories()
        const subcategories = this._getSubcategories()

        // TODO dev only
        window.___import_form_props = this.props

        return (
            <Fragment>
                {
                    what === importMsexcelId &&
                    (
                        <div className="top-right-button-fld">
                            <a role="button" className="btn btn-success" href="/examples/import_tpl.xlsx" download>{formatMessage('Template')}</a>
                        </div>
                    )
                }
                <form
                    onSubmit={handleSubmit}
                    className="create-dialog-form posr"
                >

                    <Field
                        name = "category"
                        id = "category"
                        selectProps = {{
                            options : categories,
                            valueKey : "id",
                            labelKey : "name",
                            placeholder : `${formatMessage('Select')}...`,
                            noResultsText : formatMessage('No category'),
                        }}
                        validate={[required]}
                        component = {this.RenderSelect}
                        label = {formatMessage("* Choose category")}
                    />

                    <Field
                        name = "subcategory"
                        id = "subcategory"
                        selectProps = {{
                            options : subcategories,
                            valueKey : "id",
                            labelKey : "name",
                            placeholder : `${formatMessage('Select')}...`,
                            noResultsText : formatMessage('No subcategory'),
                        }}
                        component = {this.RenderSelect}
                        label = {formatMessage("Choose subcategory")}
                    />

                    {
                        submitSucceeded &&
                        <div className="row mb-3">
                            <div className="col-xs-12 text-center text-success">{formatMessage(successImportMsg)}</div>
                        </div>
                    }
                    {
                        Object.values(fileErrors).map(err => (
                            err &&
                            <div key = {err} className="row mb-3">
                                <div className="col-xs-12 text-center text-danger">{formatMessage(err)}</div>
                            </div>
                        ))
                    }
                    {
                        error &&
                        <div className="row mb-3">
                            <div className="col-xs-12 text-center text-danger">{formatMessage(error)}</div>
                        </div>
                    }
                    <div className="create-dialog-form__group flex">
                        <Dropzone
                            accept={getImportAcceptedFormats(what)}
                            onDropAccepted={this.onDropAccepted}
                            onDropRejected={this.onDropRejected}
                            style={{}}
                            multiple={false}
                            disableClick={true}
                            ref = {this.getDropzoneRef}
                            className='mr-auto'
                        >
                            <button
                                onClick={this.handleUploadClick}
                                disabled={submitting/* || !isFormValid*/}
                                className="btn btn-primary"
                                type="button"
                            >{formatMessage(okImportText)}</button>
                        </Dropzone>
                        <button
                            onClick={onCancelClick}
                            className="btn btn-warning"
                            type="button"
                        >{formatMessage(cancelImportText)}</button>
                    </div>
                </form>
            </Fragment>
        )
    }

    _getCategories = () => this.props.categories.sort(sortCB)
    _getSubcategories = () => {
        const {selectedCategory, subcategories} = this.props
        return subcategories.filter(subcat => subcat.parent_id === (selectedCategory && selectedCategory.id)).sort(sortCB)
    }

    RenderSelect = ({input, meta, ...customProps}) => {
        let { touched, error } = meta
        const {id, label, selectProps = {}} = customProps
        return (
            <div className="create-dialog-form__group create-dialog-form__group--indent-bottom">
                <label htmlFor={id}>{label}</label>
                <Select
                    {...input}
                    onBlur={() => input.onBlur(input.value)} // !!! REQUIRED !!! https://github.com/erikras/redux-form/issues/82#issuecomment-142393045
                    {...selectProps}
                />
                {
                    touched &&
                    (
                        (
                            error &&
                            <span style={{color:"red"}} className = "help-block">{this.context.formatMessage ? this.context.formatMessage(error) : error}</span>
                        )
                    )
                }
            </div>
        )
    }

    handleUploadClick = () => {
        const {isFormValid, touch, clearSubmitErrors, submitFailed} = this.props
        if (typeof touch === 'function') touch('category')

        if (submitFailed) {
            if (typeof clearSubmitErrors === 'function') clearSubmitErrors()
        }

        if (isFormValid || submitFailed) this.dropZoneRef && this.dropZoneRef.open()
    }
    getDropzoneRef = ref => this.dropZoneRef = ref

    onDropAccepted = (files) => {
        const {handleSubmit} = this.props
        const onSubmit = this._submitCB(files)
        handleSubmit(onSubmit)()
    }

    _submitCB = (files) => (values, ...rest)=>{
        const {onSubmit, what} = this.props
        const submitOpt = {
            ...values,
            file : files[0],
        }
        return onSubmit(what)(submitOpt, ...rest)
    }

    onDropRejected = (files) => {
        let file = files[0]
        let {what} = this.props
        if (!checkImportFileType(what, file.type)) {
            const formats = stringifyAcceptedFormats(what)
            this.setState((prevState) => {
                return {
                    ...prevState,
                    fileErrors : {
                        ...prevState.fileErrors,
                        format : `Only files of ${formats} formats are allowed.`
                    }
                }
            })
        }
    }

    static contextTypes = {formatMessage: PropTypes.any}
}



export default connect(
    () => {
        const importFormValuesSelector = getFormValues(importFormName)
        const isValidSelector = isValid(importFormName)
        return state => {
            let categories = parentCategoriesSelector(state)
            let subcategories = subcategoriesSelector(state)
            let _selectedCategory = importFormValuesSelector(state, 'category')

            return {
                categories,
                subcategories,
                selectedCategory : _selectedCategory && _selectedCategory.category,
                isFormValid : isValidSelector(state),
            }
        }
    }
)(reduxForm({
    form : importFormName,
    onSubmit : (what) => (values, dispatch) => {
        const {category, subcategory, file} = values
        const category_id = category && category.id
        if (what === importQtizipId) {
            dispatch(qLoaderShowModal({loadingText:"Importing..."}))
        } else {
            dispatch(showLoading(LOADER_BAR_MODAL_SCOPE))
        }



        if (!checkImportExportMenuDataItem(importId, what)) return

        return importSubmit({
            category_id,
            subcategory_id : subcategory && subcategory.id,
            file,
            what,
        })
            .then(response => {
                // TODO handle request question/list @see src/modules/questions@checkAndUploadQuestions
                if (response.toLowerCase() === 'ok') {
                    dispatch(reuploadQuestions({category_id}))

                    dispatch(importQuestionsSuccess())
                }
            })
            .finally(() => {
                if (what === importQtizipId) {
                    dispatch(qLoaderHideModal())
                } else {
                    dispatch(hideLoading(LOADER_BAR_MODAL_SCOPE))
                }
            })
    },
})(ImportForm))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/modals/ImportExport/ImportForm.js